import React from 'react';

const PrivacyHero = () => {
  return (
    <section
      style={{
        position: 'relative',
        height: '520px',
        overflow: 'hidden',
        marginTop: '72px'
      }}>
      
      {/* Background image */}
      <img
        src="https://images.unsplash.com/photo-1607387027281-86b019ee9457"
        alt="Dramatic Norwegian fjord landscape with misty mountains and dark waters reflecting stormy sky"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 30%',
          filter: 'brightness(0.35) contrast(1.2) saturate(0.6)'
        }} />
      

      {/* Gradient overlay */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(135deg, rgba(5,10,18,0.7) 0%, rgba(59,111,212,0.15) 50%, rgba(5,10,18,0.8) 100%)'
        }} />
      

      {/* Ghost number */}
      <div
        style={{
          position: 'absolute',
          top: '-20px',
          right: '5%',
          fontFamily: 'Impact, sans-serif',
          fontSize: 'clamp(8rem, 20vw, 18rem)',
          fontWeight: 900,
          color: 'rgba(59,111,212,0.06)',
          lineHeight: 1,
          userSelect: 'none',
          letterSpacing: '-0.05em'
        }}>
        
        §
      </div>

      {/* Content */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          padding: '0 5% 60px'
        }}>
        
        {/* Tag */}
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'rgba(59,111,212,0.2)',
            border: '1px solid rgba(59,111,212,0.4)',
            padding: '6px 14px',
            marginBottom: '20px',
            width: 'fit-content'
          }}>
          
          <div style={{ width: '6px', height: '6px', background: '#3B6FD4', borderRadius: '50%' }} />
          <span
            style={{
              fontFamily: 'JetBrains Mono, monospace',
              fontSize: '0.6875rem',
              color: '#3B6FD4',
              letterSpacing: '0.12em',
              textTransform: 'uppercase'
            }}>
            
            GDPR-SAMSVAR · OPPDATERT FEBRUAR 2026
          </span>
        </div>

        {/* Title */}
        <div style={{ position: 'relative' }}>
          <h1
            style={{
              fontFamily: 'Impact, sans-serif',
              fontSize: 'clamp(3rem, 8vw, 7rem)',
              fontWeight: 900,
              color: '#EEF0F2',
              lineHeight: 0.9,
              letterSpacing: '-0.02em',
              textTransform: 'uppercase',
              transform: 'rotate(-1deg)',
              transformOrigin: 'left bottom',
              marginBottom: '4px'
            }}>
            
            PERSONVERN
          </h1>
          <h2
            style={{
              fontFamily: 'Georgia, serif',
              fontStyle: 'italic',
              fontSize: 'clamp(1.25rem, 3vw, 2.25rem)',
              color: 'rgba(238,240,242,0.6)',
              fontWeight: 400,
              marginTop: '8px'
            }}>
            
            & Databeskyttelse — NordPass AS
          </h2>
        </div>
      </div>
    </section>);

};

export default PrivacyHero;